import React, { useEffect } from 'react';
import PatientHistoryPanel from './PatientHistoryPanel';
import PatientScalesPanel from './PatientScalesPanel';

export default function PreAppointmentDashboardWithData({ patientDataModel, informantData = {}, onView, displayMode = 'full', isSubclinicalService = false }) {
    
    // Call onView when the component is mounted to track viewing
    useEffect(() => {
        if (onView && typeof onView === 'function') {
            onView();
        }
    }, [onView]);
    
    return (
        <div className="flex flex-col gap-5">
           
        {/* Responsive layout: stack on mobile (flex-col), side-by-side on lg+ (lg:flex-row) */}
        <div className="flex flex-col lg:flex-row justify-between gap-3 lg:gap-5">
            <div className="w-full lg:w-1/2 lg:grow lg:shrink lg:basis-0">
                <PatientScalesPanel 
                    patientData={patientDataModel} 
                    informantData={informantData}
                    displayMode={displayMode} 
                    isSubclinicalService={isSubclinicalService} 
                />
            </div>  
    
            <div className="w-full lg:w-1/2 lg:grow lg:shrink lg:basis-0">
                <PatientHistoryPanel 
                    patientData={patientDataModel} 
                    displayMode={displayMode} 
                />
            </div>        
        </div>
        
    </div>
    );
}

